<template lang="html">
<section class="manage-users">
    <v-card class="ma-5">
        <v-list-item two-line>
            <v-list-item-content>
                <v-list-item-title class="headline">
                    ניהול משתמשים
                </v-list-item-title>
            </v-list-item-content>
            <v-btn color="success" @click="add">
                <v-icon>mdi-plus</v-icon>
                הוסף משתמש
            </v-btn>
        </v-list-item>

        <v-list-item>
            <v-alert type="error" v-if="error">{{error}}</v-alert></v-list-item>
        <v-row  v-for="user in users" class="pl-5 pr-5">
            <v-list-item-icon class="col-1">
                <v-icon large>mdi-account-circle</v-icon>
            </v-list-item-icon>

            <v-list-item-title v-if="user.edit">
                <v-form ref="form" v-model="valid">
                    <v-text-field label="אימייל" :rules="requireRules" type="email" v-model="user.email"></v-text-field>
                    <v-text-field label="סיסמא" :rules="requireRules" v-model="user.password"></v-text-field>
                    <v-text-field label="שם מלא" :rules="requireRules" v-model="user.displayName"></v-text-field>
                </v-form>
            </v-list-item-title>

            <v-list-item-title v-if="!user.edit" class="col-md-3">{{user.displayName}}</v-list-item-title>
            <v-list-item-title v-if="!user.edit" class="col-sm-6 col-md-3">{{user.email}}</v-list-item-title>
            <v-list-item-title v-if="!user.edit" class="col-ms-12 col-md-3">
                <v-autocomplete chips clearable deletable-chips multiple :items="segments" label="הרשאות" @input="selected(user)" v-model="user.customClaims.segments"></v-autocomplete>
            </v-list-item-title>
            <v-spacer></v-spacer>
            <v-checkbox v-model="user.customClaims.admin" :label="`מנהל`"  @change="selected(user)"></v-checkbox>
            <v-spacer></v-spacer>
            <v-list-item-action>
                <v-icon color="success" v-if="user.edit"  @click="save(user)">mdi-content-save</v-icon>
                <v-icon color="success" v-if="!user.edit" @click="user.edit = true">mdi-pencil</v-icon>
            </v-list-item-action>
            <v-list-item-action @click="del(user)" v-if="!user.edit">
                <v-icon color="error">mdi-delete</v-icon>
            </v-list-item-action>
        </v-row>

    </v-card>
</section>
</template>

<script lang="js">
export default {
    name: 'manage-users',
    props: [],
    mounted() {
        this.$store.dispatch('fetchUsers')
    },
    data() {
        return {
            valid: true,
            form: {},
            requireRules: [
                v => !!v || 'שדה חובה'
            ],
            error: null}
    },
    methods: {
        selected(user) {
            this.$store.dispatch('setSegments', {
                uid: user.uid,
                customClaims: user.customClaims
            })
        },
        add() {
            this.$store.getters.users.push({
                edit: true,
                customClaims: {}
            })
        },
        save(user) { 
            if (this.$refs.form[0].validate()){
                this.$store.dispatch('createUser', user)
                user.edit = false; 
            } else {
                this.error = "יש שגיאות בשדות המסומנים"
            }   
        },
        del(user) {
            this.$store.dispatch('deleteUser', user)
        }
    },
    computed: {

        users() {
            return this.$store.getters.users
        },

        segments() {
            return this.$store.getters.segments.map(x => x.name)
        }
    }
}
</script>

<style lang="scss" scoped>
.manage-users {}
</style>
